
// Default image utility
// Previous default image: https://kjfwyaniengzduyeeufq.supabase.co/storage/v1/object/public/article-images/1754119672702-57iira2y1j2.png
export const getDefaultImageUrl = () => {
  return "https://kjfwyaniengzduyeeufq.supabase.co/storage/v1/object/public/article-images/1758362136029-v4rlqj4730c.png";
};

export const DEFAULT_IMAGE_URL = getDefaultImageUrl();
